import { useEffect, useState } from "react";
import { Link, Navigate, useParams } from "react-router-dom";
import { fetchProductsWithCache } from "../utils/firestoreCache";
import "./Products.scss";

export default function Products() {
  const { category, subcategory } = useParams();
  const [products, setProducts] = useState([]);

  const showCodaco = false;

  const brandOrderShortSleeve = ["CityZen", "Rimeck Reserve", "Malfini Single"];

  const keywordOrderOthers = [
    "deštník",
    "přilba",
    "kšiltovka",
    "potisk",
    "samolepka",
  ];

  useEffect(() => {
    const loadProducts = async () => {
      const data = await fetchProductsWithCache();
      setProducts(data);
    };

    loadProducts();
  }, []);

  // Redirect fallback for / or /products
  if (!category) {
    return <Navigate to="/products/merch" replace />;
  }

  const formatPrice = (price) => {
    if (price == null || isNaN(price)) return "";
    return price.toLocaleString("cs-CZ", { useGrouping: true });
  };

  const filtered = products
    .filter((p) => {
      if (category && p.category !== category) return false;
      if (subcategory && p.subcategory !== subcategory) return false;
      return true;
    })
    .sort((a, b) => {
      if (subcategory === "kratky-rukav") {
        const brandA = brandOrderShortSleeve.findIndex((brand) =>
          a.name?.toLowerCase().includes(brand.toLowerCase()),
        );
        const brandB = brandOrderShortSleeve.findIndex((brand) =>
          b.name?.toLowerCase().includes(brand.toLowerCase()),
        );

        if (brandA !== -1 && brandB !== -1 && brandA !== brandB) {
          return brandA - brandB;
        }

        if (brandA === brandB) {
          return a.name.localeCompare(b.name, "cs", { sensitivity: "base" });
        }

        return brandA === -1 ? 1 : -1;
      }

      if (subcategory === "ostatni") {
        const indexA = keywordOrderOthers.findIndex((kw) =>
          a.name?.toLowerCase().includes(kw.toLowerCase()),
        );
        const indexB = keywordOrderOthers.findIndex((kw) =>
          b.name?.toLowerCase().includes(kw.toLowerCase()),
        );

        if (indexA !== -1 && indexB !== -1 && indexA !== indexB) {
          return indexA - indexB;
        }

        if (indexA === indexB) {
          return a.name.localeCompare(b.name, "cs", { sensitivity: "base" });
        }

        return indexA === -1 ? 1 : -1;
      }

      return a.name.localeCompare(b.name, "cs", { sensitivity: "base" });
    });

  return (
    <main className="products products--with-sidebar">
      <aside key={category} className="products__sidebar">
        {/*<div className="products__sidebar-intro">
          <h1 className="products__sidebar-title">Firemní merch</h1>
          <p className="products__sidebar-text">Vyberte kategorii produktů.</p>
        </div> */}

        <ul>
          <li>
            <Link
              to="/products/merch"
              className={`products__cat-link ${
                category === "merch" ? "active" : ""
              }`}
            >
              Firemní merch
            </Link>

            {category === "merch" && (
              <ul className="products__subnav">
                <li>
                  <Link
                    to="/products/merch/kratky-rukav"
                    className={subcategory === "kratky-rukav" ? "active" : ""}
                  >
                    Krátký rukáv
                  </Link>
                </li>
                <li>
                  <Link
                    to="/products/merch/dlouhy-rukav"
                    className={subcategory === "dlouhy-rukav" ? "active" : ""}
                  >
                    Dlouhý rukáv
                  </Link>
                </li>
                <li>
                  <Link
                    to="/products/merch/ostatni"
                    className={subcategory === "ostatni" ? "active" : ""}
                  >
                    Ostatní
                  </Link>
                </li>
              </ul>
            )}
          </li>

          {showCodaco && (
            <li>
              <Link
                to="/products/produkty"
                className={`products__cat-link ${
                  category === "produkty" ? "active" : ""
                }`}
              >
                Produkty Codaco
              </Link>

              {category === "produkty" && (
                <ul className="products__subnav">
                  <li>
                    <Link
                      to="/products/produkty/sesterna"
                      className={subcategory === "sesterna" ? "active" : ""}
                    >
                      Sesterna
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/products/produkty/pokoj"
                      className={subcategory === "pokoj" ? "active" : ""}
                    >
                      Pokoj pacienta
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/products/produkty/socialni"
                      className={subcategory === "socialni" ? "active" : ""}
                    >
                      Sociální zařízení
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/products/produkty/chodba"
                      className={subcategory === "chodba" ? "active" : ""}
                    >
                      Chodba
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/products/produkty/vchod"
                      className={subcategory === "vchod" ? "active" : ""}
                    >
                      Vchod
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/products/produkty/ostatni_produkt"
                      className={
                        subcategory === "ostatni_produkt" ? "active" : ""
                      }
                    >
                      Ostatní
                    </Link>
                  </li>
                </ul>
              )}
            </li>
          )}
        </ul>
      </aside>

      <section className="products__content">
        {subcategory && (
          <>
            {filtered.length === 0 ? (
              <p className="products__empty-state">
                Žádné produkty nejsou k dispozici.
              </p>
            ) : (
              <div key={subcategory} className="products__grid">
                {filtered.map((product) => (
                  <div key={product.id} className="products__card">
                    <Link to={`/product/${product.id}`}>
                      {product.images?.length > 0 && (
                        <img
                          src={product.images[0]}
                          alt={product.name}
                          className="products__image"
                          loading="lazy"
                        />
                      )}

                      <h2 className="products__name">{product.name}</h2>
                    </Link>

                    <div className="card__bottom">
                      <p className="products__price">
                        {formatPrice(product.price)} Kč
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </>
        )}
      </section>
    </main>
  );
}
